import React, {Component} from 'react';
import {
    Button,
    Carousel,
    CarouselControl, CarouselIndicator, CarouselIndicators,
    CarouselInner,
    CarouselItem,
    Col,
    ListGroup,
    ListGroupItem,
    Row
} from "mdbreact";
import {API_URL, IMAGE_URL} from "../../config/Config";
import axios from "axios/index";
import MerchantMap from "../../components/map/MerchantMap";
import {Breadcrumb, BreadcrumbItem, Card, CardText, Container, Media} from "reactstrap";
import {Link} from "react-router-dom";
import renderHTML from 'react-render-html';
import PageLoader from "../../components/loader/PageLoader";

export default class MerchantItem extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.state = {
            activeItem: 0,
            maxLength:1,
            merchant:{},
            categories:[],
            images:[],
            catName:'',
            lat: 35.739581,
            lng: 51.432568,
            name:'',
            loading:false,
            id:0,
        };
    }
    async componentDidMount(){
        const { params } = this.props.match;
        let id = await params.id;
        if (id){
            this.setState({id});
            await this.getBussinessObject();
        }
        this.setState({loading:true});
    }
    async getBussinessObject(){

        let response = await axios.get(`${API_URL}business/${this.state.id}`);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            alert('خطایی در هنگام دریافت اطلاعات از سرور رخ داد.');

        }else{
            let merchant = response.data.data;
            let images = response.data.data.galleries;
            let categories = merchant.categories;
            let maxLength=images.length+1;
            this.setState({merchant,images,categories,maxLength});
        }
    }
    next() {
        let nextItem = this.state.activeItem + 1;
        if(nextItem >= this.state.maxLength) {
            this.setState({ activeItem: 0 });
        } else {
            this.setState({ activeItem: nextItem });
        }
    }

    prev() {
        let prevItem = this.state.activeItem - 1;
        if(prevItem < 0) {
            this.setState({ activeItem: this.state.maxLength-1 });
        } else {
            this.setState({ activeItem: prevItem });
        }
    }

    goToIndex(item) {
        if (this.state.activeItem !== item) {
            this.setState({
                activeItem: item
            });
        }
    }

    render() {
        const { merchant,categories,images,activeItem} = this.state;

        return (
            <div className="pt-3">
                {!this.state.loading ? <PageLoader type="bubbles" color="#4fbfa8"/> :
                    <Container>
                        <Breadcrumb className='w-100 white mt-3 rtl'>
                            <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                            {/*<BreadcrumbItem><Link to="/merchantList">کسب و کارها</Link></BreadcrumbItem>*/}
                            <BreadcrumbItem active>{merchant.title}</BreadcrumbItem>
                        </Breadcrumb>

                        <div className="container rtl mt-3 mb-5 white pt-3" style={{minHeight: 500, marginTop: 100}}>
                            <Row>
                                <Col>
                                    <h1 className="teal-text">{merchant.title}</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" sm="12" className="white p-3">
                                    <Card body>
                                        <CardText>{merchant.short_desc}</CardText>
                                    </Card>
                                    <hr/>
                                    <div className="text-justify mt-4 md-6">{renderHTML(merchant.description)}</div>
                                    <Media className='mt-3'>
                                        <Media left href="#">
                                            <Media object src={`${IMAGE_URL}${merchant.user.pic}`} alt={`${merchant.user.firstname} ${merchant.user.lastname}`} className="rounded-circle" style={{width:100,height:100}}/>
                                        </Media>
                                        <Media body className='p-3'>
                                            <div className="mt-4">
                                                <strong>{merchant.user.firstname} {merchant.user.lastname}</strong>
                                            </div>
                                        </Media>
                                    </Media>
                                </Col>
                                <Col md="6" sm="12">
                                    {/*<img src={IMAGE_URL + merchant.cover} alt={merchant.name} className="w-100"/>*/}
                                    <Carousel
                                        thumbnails
                                        activeItem={activeItem}
                                        next={this.next}
                                        className="mt-3">
                                        <CarouselInner>
                                            <CarouselItem itemId="0">
                                                <img className="d-block w-100" src={IMAGE_URL+merchant.cover} alt={merchant.title} />
                                            </CarouselItem>
                                            {images.map((image,index) =>
                                                <CarouselItem itemId={index+1} key={index}>
                                                    <img className="d-block w-100" src={IMAGE_URL+image.image_url} alt={image.image_title} />
                                                </CarouselItem>
                                            )}
                                        </CarouselInner>
                                        <CarouselControl direction="prev" role="button" onClick={() => { this.prev(); }} />
                                        <CarouselControl direction="next" role="button" onClick={() => { this.next(); }} />
                                        <CarouselIndicators>
                                            <CarouselIndicator img={IMAGE_URL+merchant.cover} active={activeItem === 0 ? true : false} onClick={() => { this.goToIndex(0); }}></CarouselIndicator>

                                            {images.map((image,index) =>
                                                <CarouselIndicator key={index} img={IMAGE_URL+image.image_url} active={activeItem === (index+1) ? true : false} onClick={() => { this.goToIndex(index+1); }}></CarouselIndicator>
                                            )}
                                        </CarouselIndicators>
                                    </Carousel>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr/>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" sm="12">
                                    <ListGroup className="list-flat">
                                        <ListGroupItem><strong>شهر :</strong>{merchant.city.name}</ListGroupItem>
                                        <ListGroupItem><strong>آدرس :</strong>{merchant.address}</ListGroupItem>
                                        <ListGroupItem><strong>شماره تماس :</strong>{merchant.phone}</ListGroupItem>
                                        <ListGroupItem><strong>وب سایت :</strong> <a href={merchant.website} target="_blank">{merchant.website}</a></ListGroupItem>
                                        <ListGroupItem><strong>کدپستی :</strong>{merchant.postal_code}</ListGroupItem>
                                    </ListGroup>
                                </Col>
                                <Col md="6" sm="12">
                                    <ListGroup className="list-flat">
                                        <ListGroupItem><strong>اینستاگرام :</strong>{merchant.instagram}</ListGroupItem>
                                        <ListGroupItem><strong>تلگرام :</strong>{merchant.telegram}</ListGroupItem>
                                        <ListGroupItem><strong>واتس آپ :</strong>{merchant.whatsapp}</ListGroupItem>
                                        <ListGroupItem><strong>دسته :</strong> <Button >{categories[0].name}</Button> | <Button >{categories[1].name}</Button> </ListGroupItem>
                                    </ListGroup>
                                </Col>

                            </Row>
                            <Row>
                                <Col className="mt-5 mb-5">
                                    <MerchantMap lat={this.state.lat} lng={this.state.lng} name={this.state.name}/>
                                </Col>
                            </Row>

                        </div>
                    </Container>
                }

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/merchants/MerchantItem.js